// ---------------------
// ------ On resize screen -----
// ---------------------
if (mobile != true) {
    window.addEventListener("resize", resizeWindows);
}


function resizeWindows() {
    // console.log('resizing');
    // Uptdate Lomocotive scroll
    // scroll.update();
    //fullHeight();
}
